import React from "react";
import { useNavigate } from "react-router-dom";
import "../style/aboutus.css";
import { Typography } from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FaCheckCircle } from "react-icons/fa";
import img1 from "../images/gallery-photo1.jpg";
import img2 from "../images/cheerful-young-girl-washes-windows-with-blue-towel-min.jpg";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

const aosBase = {
  "data-aos": "fade-left",
  "data-aos-duration": "800",
  "data-aos-easing": "ease-out-cubic",
  "data-aos-once": "true",
};

const priceItems = [
  { label: "Fensterreinigung",    price: "ab 35€" },
  { label: "Umzugsreinigung",     price: "ab 33€" },
  { label: "Unterhaltsreinigung", price: "ab 31€" },
  { label: "Büroreinigung",       price: "ab 31€" },
  { label: "Grundreinigung",      price: "ab 45€" },
  { label: "Bauendreinigung",     price: "ab 42€" },
];

function Aboutus() {
  React.useEffect(() => {
    AOS.init({
      offset: 80,
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  const navigate = useNavigate();

  return (
    <div className="aboutus">

      {/* ── IMAGE PANEL ── */}
      <div className="image-div-aboutus">
        <div
          className="first-image-about"
          data-aos="fade-right"
          data-aos-duration="900"
          data-aos-easing="ease-out-cubic"
          data-aos-once="true"
        >
          <LazyLoadImage src={img1} alt="Reinigungsteam" />
        </div>

        <div
          className="second-image-about"
          data-aos="fade-right"
          data-aos-delay="150"
          data-aos-duration="900"
          data-aos-easing="ease-out-cubic"
          data-aos-once="true"
        >
          <LazyLoadImage src={img2} alt="Fensterreinigung" />
        </div>

        <div
          className="third-image-about"
          data-aos="fade-left"
          data-aos-delay="250"
          data-aos-duration="900"
          data-aos-easing="ease-out-cubic"
          data-aos-once="true"
        >
          <LazyLoadImage src={img2} alt="Reinigung" />
        </div>

        {/* floating years badge */}
        <div className="about-badge">
          <strong>10+</strong>
          <span>Jahre Erfahrung</span>
        </div>
      </div>

      {/* ── TEXT PANEL ── */}
      <div className="text-content-about">
        <div className="text-aboutus">

          {/* eyebrow */}
          <span
            className="about-eyebrow"
            data-aos="fade-left"
            data-aos-duration="600"
            data-aos-once="true"
          >
            Über uns
          </span>

          {/* title */}
          <Typography
            {...aosBase}
            data-aos-delay="80"
            variant="h4"
            className="aboutustitle"
            gutterBottom
            sx={{
              fontSize: "30px",
              fontFamily: "var(--fontFamily)",
              fontWeight: 700,
              color: "var(--textColor)",
              lineHeight: 1.25,
            }}
          >
            Wir bringen Ihren Platz zum Strahlen
          </Typography>

          {/* intro */}
          <Typography
            {...aosBase}
            data-aos-delay="120"
            variant="body2"
            sx={{ lineHeight: "1.7rem", color: "var(--textColor)" }}
          >
            Wir legen großen Wert auf Kundenzufriedenheit und sind erst dann
            zufrieden, wenn Sie es sind. Vertrauen Sie auf unsere
            Professionalität und lassen Sie uns Ihren Reinigungsbedarf
            übernehmen.
          </Typography>

          {/* price list */}
          <div
            data-aos="fade-left"
            data-aos-delay="160"
            data-aos-duration="800"
            data-aos-once="true"
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontSize: "15px",
                color: "var(--textColor)",
                marginBottom: "8px",
                fontFamily: "var(--fontFamily)",
              }}
            >
              Professionelle Leistungen:
            </Typography>

            {priceItems.map((item, i) => (
              <div
                className="check-item"
                key={i}
                data-aos="fade-left"
                data-aos-delay={180 + i * 60}
                data-aos-duration="600"
                data-aos-once="true"
              >
                <FaCheckCircle className="checkicon" />
                <span style={{ fontFamily: "var(--fontFamily)", fontSize: "14px" }}>
                  {item.label}
                </span>
                <span className="price-pill">{item.price}</span>
              </div>
            ))}
          </div>

          {/* closing text */}
          <Typography
            {...aosBase}
            data-aos-delay="560"
            variant="body2"
            sx={{ lineHeight: "1.75rem", color: "var(--textColor)" }}
          >
            Mit unserem engagierten Team und unserer Liebe zum Detail streben
            wir stets nach Perfektion, um Ihren Anforderungen gerecht zu werden.
            Kontaktieren Sie uns noch heute, um herauszufinden, wie wir Ihnen
            helfen können, eine saubere und gesunde Umgebung zu schaffen.
          </Typography>

          {/* CTA */}
          <Stack
            data-aos="fade-up"
            data-aos-delay="620"
            data-aos-duration="700"
            data-aos-once="true"
          >
            <Button
              variant="contained"
              onClick={() => navigate("/uberuns")}
              className="Kontaktanfrage-absenden"
              sx={{
                width: { xs: "90%", sm: 220, md: 300, lg: 380, xl: 420 },
                backgroundColor: "#01B8B0",
                fontSize: "18px",
                fontFamily: "var(--fontFamily)",
                fontWeight: 600,
                marginTop: "16px",
                borderRadius: "10px",
                textTransform: "none",
                boxShadow: "0 6px 24px rgba(1,184,176,0.35)",
                transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)",
                "&:hover": {
                  backgroundColor: "#00918a",
                  transform: "translateY(-3px)",
                  boxShadow: "0 12px 32px rgba(1,184,176,0.45)",
                },
              }}
            >
              Kontaktanfrage absenden
            </Button>
          </Stack>

        </div>
      </div>
    </div>
  );
}

export default Aboutus;